<template>
<!-- eslint-disable -->
<div class="v-docs">
<div class="markdown-body"><h1>vue-component-devtool</h1>
<blockquote>
<p>通过 <a href="https://cli.vuejs.org">vue-cli</a> 初始化；采用 <a href="https://github.com/mengdu/vue-dotmd-loader">vue-dotmd-loader</a> 来加载文档。</p>
</blockquote>
<p>基于 webpack 的 Vue 组件开发工具。可以编写例子，文档。</p>
<p><strong>use</strong></p>
<pre class="language language-ls" data-lang="ls"><code v-html="'git clone https:&lt;span class=&quot;hljs-regexp&quot;&gt;//github.com/mengdu/vue-component-devtool my-component\n&lt;/span&gt;'"></code></pre>
<p><strong>安装依赖</strong></p>
<pre class="language language-ls" data-lang="ls"><code v-html="'yarn\n&lt;span class=&quot;hljs-comment&quot;&gt;# or&lt;/span&gt;\n&lt;span class=&quot;hljs-built_in&quot;&gt;npm&lt;/span&gt; install\n'"></code></pre>
<p><strong>功能</strong></p>
<ul>
<li>打包vue组件，导出 <code>umd</code> 模式</li>
<li>支持 <code>markdown</code> 解析</li>
<li><code>markdwon</code> 可以编写编写vue例子</li>
</ul>
<p><strong>目录</strong>：</p>
<pre class="language language-text" data-lang="text"><code v-html="'├─&lt;span class=&quot;hljs-selector-tag&quot;&gt;build&lt;/span&gt; 开发工具\n├─&lt;span class=&quot;hljs-selector-tag&quot;&gt;docs&lt;/span&gt; 打包后的文档\n├─&lt;span class=&quot;hljs-selector-tag&quot;&gt;dist&lt;/span&gt; 打包后库\n│  ├─&lt;span class=&quot;hljs-selector-tag&quot;&gt;index&lt;/span&gt;&lt;span class=&quot;hljs-selector-class&quot;&gt;.umd&lt;/span&gt;&lt;span class=&quot;hljs-selector-class&quot;&gt;.js&lt;/span&gt;\n│  └─&lt;span class=&quot;hljs-selector-tag&quot;&gt;index&lt;/span&gt;&lt;span class=&quot;hljs-selector-class&quot;&gt;.css&lt;/span&gt;\n├─&lt;span class=&quot;hljs-selector-tag&quot;&gt;src&lt;/span&gt; 组件源码\n├─&lt;span class=&quot;hljs-selector-tag&quot;&gt;examples&lt;/span&gt; 文档源码\n'"></code></pre>
<p><strong>开发模式</strong>（支持热更新）</p>
<pre class="language language-ls" data-lang="ls"><code v-html="'&lt;span class=&quot;hljs-built_in&quot;&gt;npm&lt;/span&gt; run dev\n'"></code></pre>
<p>打开 <code>http://localhost:8080</code> 查看效果。</p>
<p><strong>打包组件</strong></p>
<pre class="language language-ls" data-lang="ls"><code v-html="'&lt;span class=&quot;hljs-built_in&quot;&gt;npm&lt;/span&gt; run build:lib\n'"></code></pre>
<p>打包后组件被打包成js和css在 <code>dist</code> 文件夹中。</p>
<p><strong>生成文档</strong></p>
<pre class="language language-ls" data-lang="ls"><code v-html="'&lt;span class=&quot;hljs-built_in&quot;&gt;npm&lt;/span&gt; run build:docs\n'"></code></pre>
<p>生成文档在 <code>docs</code> 文件夹，打开 <code>index.html</code> 可以浏览。上传 Github 后可以开启项目 Page 访问。</p>
<h2>Other</h2>
<p><a href="https://github.com/mengdu/vue-dotmd-loader">vue-dotmd-loader</a></p>
<hr>
</div>
</div>
</template>

    <script>
      /** eslint-disable **/
      

      
      
      export default {
        components: {
          
        },
        mixins: [
          
        ]
      }
    </script>
